import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnFilterPopupComponent } from './column-filter-popup.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ColumnFilterPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
],
  exports:[
    ColumnFilterPopupComponent
  ]
})
export class ColumnFilterPopupModule { }
